import ComplianceOverview from "@/components/probaworkflows_base_components/ComplianceOverview/ComplianceOverview.vue";
import BeneficiaryDashboard from "@/views/beneficiary_portal/beneficiary_dashboard/BeneficiaryDahsboard.vue";
import BeneficiaryDistributions from "@/views/beneficiary_portal/beneficiary_distributions/BeneficiaryDistributions.vue";
import FounderDashboard from "@/views/founder_portal/founder_dashboard/FounderDashboard.vue";
import AssetsRegistry from "@/views/probaworkflows_base/Assets/AssetsRegistry/AssetsRegistry.vue";
import AnswerRiskAssessment from "@/views/probaworkflows_base/entity/answer_risk_assessment/AnswerRiskAssessment.vue";
import EnquiryChat from "@/views/probaworkflows_base/entity/enquiry_chat/EnquiryChat.vue";
import ApplicationOverviewDetails from "@/views/probaworkflows_base/entity/entity_applications/application_overview_details/ApplicationOverviewDetails.vue";
import EntityApplicationOverview from "@/views/probaworkflows_base/entity/entity_applications/entity_application_overview/EntityApplicationOverview.vue";
import EntityDocuments from "@/views/probaworkflows_base/entity/entity_applications/entity_documents/EntityDocuments.vue";
import EntityInvoiceOverview from "@/views/probaworkflows_base/entity/entity_applications/entity_invoice_overview/EntityInvoiceOverview.vue";
import EntityEnquiryManagement from "@/views/probaworkflows_base/entity/entity_enquiry_management/EntityEnquiryManagement.vue";
import EntityRiskAssessment from "@/views/probaworkflows_base/entity/entity_risk_assessment/EntityRiskAssessment.vue";
import LeadQuestionnaire from "@/views/probaworkflows_base/entity/lead_questionnaire/LeadQuestionnaire.vue";
import LeadQuestionnaireForm from "@/views/probaworkflows_base/entity/lead_questionnaire_form/LeadQuestionnaireForm.vue";
import ProofOfPayments from "@/views/probaworkflows_base/entity/proof_of_payments/ProofOfPayments.vue";
import RequestedInformationUpdate from "@/views/probaworkflows_base/entity/requested_information/requested_infomation_update/RequestedInformationUpdate.vue";
import ResolvedRequests from "@/views/probaworkflows_base/entity/requested_information/resolved_requests/ResolvedRequests.vue";
import UnresolvedRequest from "@/views/probaworkflows_base/entity/requested_information/unresolved_request/UnresolvedRequest.vue";
import ViewContracts from "@/views/probaworkflows_base/entity/view_contracts/ViewContracts.vue";
import ViewTrustForm from "@/views/probaworkflows_base/entity/view_trust_form/ViewTrustForm.vue";
import PackageServices from "@/views/probaworkflows_base/invoicing/package_services/PackageServices.vue";
import Services from "@/views/probaworkflows_base/invoicing/services/ProjectServices.vue";
import AssignQuestionsToEnquiryForm from "@/views/probaworkflows_base/management/customer_management/assign_questions_to_enquiry_form/AssignQuestionsToEnquiryForm.vue";
import CreateEnquiryForm from "@/views/probaworkflows_base/management/customer_management/create_enquiry_form/CreateEnquiryForm.vue";
import CreateEnquiryStages from "@/views/probaworkflows_base/management/customer_management/create_enquiry_stages/CreateEnquiryStages.vue";
import CreateTransitionRules from "@/views/probaworkflows_base/management/customer_management/create_transition_rules/CreateTransitionRules.vue";
import UploadMeetingMinutes from "@/views/probaworkflows_base/management/customer_management/upload_meeting_minutes/UploadMeetingMinutes.vue";
import ManageAssignedWorkflows from "@/views/probaworkflows_base/management/entity_management/approval_rules_management/manage_assigned_workflows/ManageAssignedWorkflows.vue";
import LeadsResponses from '@/views/probaworkflows_base/management/leads_management/leads_responses/LeadsResponses.vue';
import LeadsManagement from "@/views/probaworkflows_base/management/leads_management/manage_leads/LeadsManagement.vue";
import PaymentApproval from '@/views/probaworkflows_base/management/leads_management/payment_approval/PaymentApproval.vue';
import TrustDirectory from "@/views/probaworkflows_base/management/manage_approved_applicants/trust_directory/TrustDirectory.vue";
import ViewApprovedApplicant from "@/views/probaworkflows_base/management/manage_approved_applicants/view_approved_applicant/ViewApprovedApplicant.vue";
import ManageRisks from "@/views/probaworkflows_base/management/risk_management/ManageRisks.vue";
import RiskQuestions from "@/views/probaworkflows_base/management/risk_management/risk_questions/RiskQuestions.vue";
import TrustReports from "@/views/probaworkflows_base/management/trust_reports/TrustReports.vue";
import VerificationServicesConfigurations from "@/views/probaworkflows_base/verification/verification_services_configurations/VerificationServicesConfigurations.vue";
import TrusteeViewDashboard from "@/views/trustee_portal/trustee_view_dashboard/TrusteeViewDashboard.vue";
import ViewBeneficiaries from "@/views/trustee_portal/view_beneficiaries/ViewBeneficiaries.vue";
import ViewTrustees from "@/views/trustee_portal/view_trustees/ViewTrustees.vue";

const probaworkflowssupplemental = [
  // enquiry
  {
    path: "/create_enquiry_stages",
    name: "create_enquiry_stages",
    component: CreateEnquiryStages,
    meta: {
      breadcrumb: "Enquiry Status Management",
      branch: 'configure',
      isTab: true
    }
  },
  {
    path: "/create_transition_rules",
    name: "create_transition_rules",
    component: CreateTransitionRules,
  },
  {
    path: "/create_enquiry_form",
    name: "create_enquiry_form",
    component: CreateEnquiryForm,
    meta: {
      breadcrumb: "Enquiry Management",
      branch: 'configure',
      isTab: true
    }
  },
  {
    path: "/assign_questions_to_enquiry_form",
    name: "assign_questions_to_enquiry_form",
    component: AssignQuestionsToEnquiryForm,
    meta: {
      breadcrumb: "Enquiry Form Questions",
      branch: 'configure',
      isDynamic: true
    }
  },
  {
    path: "/trust_reports",
    name: "trust_reports",
    component: TrustReports,
  },
  {
    path: "/leads_management",
    name: "leads_management",
    component: LeadsManagement,
    meta: {
      breadcrumb: "Leads Management",
      branch: 'overview',
      isTab: true
     }
  },
  {
    path: '/leads_responses',
    name: 'leads_responses',
    component: LeadsResponses,
    meta: {
      breadcrumb: "Leads Responses",
      branch: 'overview',
      isDynamic: true
    }
  },
  {
    path: '/payment_approval',
    name: 'payment_approval',
    component: PaymentApproval
  },
  {
    path: "/manage_assigned_workflows",
    name: "manage_assigned_workflows",
    component: ManageAssignedWorkflows,
    meta: {
      breadcrumb: "Status Assignment Management",
      branch: 'configure',
      isDynamic: true
    }
  },
  {
    path: "/upload_meeting_minutes",
    name: "upload_meeting_minutes",
    component: UploadMeetingMinutes,
  },
  {
    path: "/entity_enquiry_management",
    name: "entity_enquiry_management",
    component: EntityEnquiryManagement,
  },
  {
    path: "/proof_of_payments",
    name: "proof_of_payments",
    component: ProofOfPayments,
  },
  // pages on founder side
  {
    path: "/beneficiary_dashboard",
    name: "beneficiary_dashboard",
    component: BeneficiaryDashboard,
  },
  {
    path: "/founder_dashboard",
    name: "founder_dashboard",
    component: FounderDashboard,
  },
  {
    path: "/beneficiary_distributions",
    name: "beneficiary_distributions",
    component: BeneficiaryDistributions,
  },
  {
    path: "/view_all_user_forms",
    name: "view_all_user_forms",
    component: ViewTrustForm,
  },
  {
    path: "/requested_information_update",
    name: "requested_information_update",
    component: RequestedInformationUpdate,
  },
  {
    path: "/unresolved_request",
    name: "unresolved_request",
    component: UnresolvedRequest,
  },
  {
    path: "/resolved_requests",
    name: "resolved_requests",
    component: ResolvedRequests,
  },
  {
    path: "/enquiry_chat",
    name: "enquiry_chat",
    component: EnquiryChat,
  },
  {
    path: "/lead_questionnaire",
    name: "lead_questionnaire",
    component: LeadQuestionnaire,
  },
  {
    path: "/lead_questionnaire_form",
    name: "lead_questionnaire_form",
    component: LeadQuestionnaireForm,
  },
  {
    path: "/view_contracts",
    name: "view_contracts",
    component: ViewContracts,
  },
  {
    path: "/entity_risk_assessment",
    name: "entity_risk_assessment",
    component: EntityRiskAssessment,
  },
  {
    path: "/entity_application_overview",
    name: "entity_application_overview",
    component: EntityApplicationOverview,
    meta: {
      breadcrumb: "My Profile",
      branch: 'overview',
      isTab: true
    }
  },
  {
    path: "/view_trustees",
    name: "view_trustees",
    component: ViewTrustees,
  },
  {
    path: "/view_beneficiaries",
    name: "view_beneficiaries",
    component: ViewBeneficiaries,
  },
  {
    path: "/trustee_view_dashboard",
    name: "trustee_view_dashboard",
    component: TrusteeViewDashboard,
  },
  {
    path: "/entity_documents",
    name: "entity_documents",
    component: EntityDocuments,
  },
  {
    path: "/asset_registry",
    name: "asset_registry",
    component: AssetsRegistry,
  },
  {
    path: "/compliance_overview",
    name: "compliance_overview",
    component: ComplianceOverview,
  },
  {
    path: "/application_overview_details",
    name: "application_overview_details",
    component: ApplicationOverviewDetails,
  },
  {
    path: "/manage_risks",
    name: "manage_risks",
    component: ManageRisks,
    meta: {
      breadcrumb: "Risks Management",
      branch: 'configure',
      isTab: true
    }
  },
  {
    path: "/risk_questions",
    name: "risk_questions",
    component: RiskQuestions,
    meta: {
      breadcrumb: "Risk Questions",
      branch: 'configure',
      isDynamic: true
    }
  },
  {
    path: "/answer_risk_assessment",
    name: "answer_risk_assessment",
    component: AnswerRiskAssessment,
  },
  {
    path: "/entity_invoice_overview",
    name: "entity_invoice_overview",
    component: EntityInvoiceOverview,
  },
  {
    path: "/entity_overview",
    name: "entity_overview",
    component: ViewTrustForm
  },
  {
    path: "/trust_directory",
    name: "trust_directory",
    component: TrustDirectory,
  },
  {
    path: "/view_approved_applicant",
    name: "view_approved_applicant",
    component: ViewApprovedApplicant,
  },
  {
    path: "/services",
    name: "services",
    component: Services,
    meta: {
      breadcrumb: "Services Management",
      branch: 'configure',
      isTab: true
    }
  },
  {
    path: "/package_services",
    name: "package_services",
    component: PackageServices,
    meta: {
      breadcrumb: "Package Management",
      branch: 'configure',
      isTab: true
    }
  },
  {
    path: "/verification_services_configurations",
    name: "verification_services_configurations",
    component: VerificationServicesConfigurations,
    meta: {
      breadcrumb: "Verification Services",
      branch: 'configure',
      isTab: true
    }
  }
];

export default probaworkflowssupplemental;
